import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { sanityClient } from "../lib/sanityClient";

const CategoryDropdown = () => {
  const [categories, setCategories] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const query = `*[_type == "category"]{ _id, title, slug }`;
        const data = await sanityClient.fetch(query);
        setCategories(data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);

  return (
    <div className="relative">
      <button
        className="text-white bg-blue-600 px-4 py-2 rounded-md hover:bg-blue-700 transition"
        onClick={() => setIsDropdownOpen((prev) => !prev)}
      >
        Collections
      </button>
      {isDropdownOpen && (
        <ul className="absolute bg-white text-black mt-2 w-48 shadow-lg rounded-md border">
          {categories.map((category) => (
            <li key={category._id} className="hover:bg-gray-100">
              <Link
                to={`/collections/${category.slug?.current}`}
                className="block px-4 py-2"
                onClick={() => setIsDropdownOpen(false)}
              >
                {category.title || "Untitled Category"}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CategoryDropdown;
